/**
 * CSVダウンロード用のモックURL作成
 * @param records CSVデータ
 * @param includeBom BOM有無（デフォルト：false）
 * @returns CSVダウンロード用のモックURL
 */
export const createCsvMockEndpoint = (records: string[][], includeBom = false) => {
  const data = records
    .map((record) => record.join(','))
    .join('\r\n');
  const bom = includeBom ? new Uint8Array([0xEF, 0xBB, 0xBF]) : new Uint8Array();
  const blob = new Blob([bom, data], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  return url;
};
